"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = __importStar(require("prop-types"));
var React = __importStar(require("react"));
var getProp_1 = __importDefault(require("sportnet-utilities/lib/getProp"));
var InputAutocomplete_1 = __importDefault(require("../InputAutocomplete"));
var AsyncInputAutocomplete = /** @class */ (function (_super) {
    __extends(AsyncInputAutocomplete, _super);
    function AsyncInputAutocomplete(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            itemsByQuery: {},
        };
        _this.getData = _this.getData.bind(_this);
        return _this;
    }
    AsyncInputAutocomplete.prototype.componentDidMount = function () {
        this.getData(this.props);
    };
    AsyncInputAutocomplete.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.value !== this.props.value) {
            this.getData(this.props);
        }
    };
    AsyncInputAutocomplete.prototype.getData = function (props) {
        var _a;
        var _this = this;
        var value = props.value;
        // when cache is true and data for current value exist don't make new reuqest
        if (props.cache && this.state.itemsByQuery[value])
            return;
        this.setState({
            itemsByQuery: __assign(__assign({}, this.state.itemsByQuery), (_a = {}, _a[value] = { itemsByQuery: [], isFetching: true }, _a)),
        });
        props.getItems(value).then(function (resp) {
            var _a;
            _this.setState({
                itemsByQuery: __assign(__assign({}, _this.state.itemsByQuery), (_a = {}, _a[value] = { itemsByQuery: resp, isFetching: false }, _a)),
            });
        });
    };
    AsyncInputAutocomplete.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, onChange = _a.onChange, onSelectItem = _a.onSelectItem, otherProps = __rest(_a, ["value", "onChange", "onSelectItem"]);
        return (React.createElement(InputAutocomplete_1.default, __assign({}, otherProps, { value: value, onChange: onChange, items: getProp_1.default(this.state, ['itemsByQuery', value, 'itemsByQuery'], []), onSelectItem: onSelectItem, loading: getProp_1.default(this.state, ['itemsByQuery', value, 'isFetching'], false), onFocus: function () { return _this.getData(_this.props); } })));
    };
    AsyncInputAutocomplete.propTypes = {
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        getItemLabel: PropTypes.func,
        onSelectItem: PropTypes.func.isRequired,
        getItems: PropTypes.func.isRequired,
        cache: PropTypes.bool,
    };
    AsyncInputAutocomplete.defaultProps = {
        getItemLabel: null,
        cache: false,
    };
    return AsyncInputAutocomplete;
}(React.Component));
exports.default = AsyncInputAutocomplete;
